import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { OnboardingChecklist } from 'components/index';
import { selectCurrentUser } from 'ducks/user.duck';
import useOnboardingSteps from './useOnboardingSteps';

const FloatingOnboardingChecklistContainer = () => {
  const { pathname } = useLocation();
  const currentUser = useSelector(selectCurrentUser);
  const onboardingPosition = currentUser?.attributes?.profile?.publicData?.onboardingPosition;
  const [isMinified, setIsMinified] = useState(onboardingPosition === 'list-a-class');
  const prevPosition = useRef(onboardingPosition);

  const { isActive, steps } = useOnboardingSteps({ onAction: () => setIsMinified(true) });

  useEffect(() => {
    if (prevPosition.current !== onboardingPosition) {
      prevPosition.current = onboardingPosition;
      setIsMinified(false);
    }
  }, [onboardingPosition]);

  useEffect(() => {
    const minimize = (e) => setIsMinified(typeof e.detail?.open === 'boolean' ? !e.detail.open : m => !m);
    window.addEventListener('floating-checklist:toggle', minimize);
    return () => window.removeEventListener('floating-checklist:toggle', minimize);
  }, []);

  if (!isActive || pathname === '/dashboard') return null;

  return (
    <OnboardingChecklist
      variant="floating"
      steps={steps}
      isMinified={isMinified}
      onToggleMinified={() => setIsMinified((m) => !m)}
    />
  );
};

export default FloatingOnboardingChecklistContainer;
